export default __webpack_public_path__ + "static/media/17.e6da1f55.jpg";